export const Bio = {
  name: "Sriya Yalavarthy",
  roles: [
    "Data Scientist",
    "Data Analyst",
    "Front-end Developer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/sriya632",
  resume:
    "https://drive.google.com/file/d/1jMylr-5-uA2AcSjaHCqGpgK5BmCeTaON/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/y-sriya-choudary/",
  
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
      },
    ],
  },
  {
    title: "Data Science Skills",
    skills: [
      {
        name: "Python",
        image: "https://www.vectorlogo.zone/logos/python/python-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg",
      },
      {
        name: "Tableau",
        image: "https://raw.githubusercontent.com/gilbarbara/logos/main/logos/tableau-icon.svg",
      },
      {
        name: "PowerBI",
        image:
          "https://www.vectorlogo.zone/logos/microsoft_powerbi/microsoft_powerbi-icon.svg",
      },
      {
        name: "R Programming",
        image: "https://www.vectorlogo.zone/logos/r-project/r-project-icon.svg",
      },
      {
        name: "SnowFlake",
        image:
          "https://www.vectorlogo.zone/logos/snowflake/snowflake-icon.svg",
      },
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "Pandas",
        image:
          "https://upload.vectorlogo.zone/logos/pydata_pandas/images/3379b038-0796-45fe-8467-3fba66c10b70.svg",
      },
      {
        name: "NumPy",
        image:
          "https://www.vectorlogo.zone/logos/numpy/numpy-icon.svg",
      },
      {
        name: "PyTorch",
        image:
          "https://www.vectorlogo.zone/logos/pytorch/pytorch-icon.svg",
      },
      {
        name: "TensorFlow",
        image:
          "https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg",
      },
      {
        name: "MatPlotLib",
        image:
          "https://matplotlib.org/stable/_images/sphx_glr_logos2_001_2_00x.png",
      },
      {
        name: "Keras",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/keras/keras-original-wordmark.svg",
      },
      {
        name: "Scikit-learn",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Adobe XD",
        image:
          "https://upload.vectorlogo.zone/logos/adobe_illustrator/images/8cf40c06-e920-4d78-8171-6941d7ab675e.svg",
      },
      {
        name: "Figma",
        image:
          "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://scontent-atl3-1.xx.fbcdn.net/v/t39.30808-1/240905456_3086887154927530_701848144440641831_n.jpg?stp=dst-jpg_s100x100_tt6&_nc_cat=100&ccb=1-7&_nc_sid=fe756c&_nc_ohc=H9MBCFiGaY8Q7kNvgEx896S&_nc_zt=24&_nc_ht=scontent-atl3-1.xx&edm=AA7a7sEEAAAA&_nc_gid=AaTlu5gBVYfQ21Dy-3OzSsC&oh=00_AYDs9MbJ2B2AI-8rj26gtgVaSFkn_xiDGrK896cm2q5jOQ&oe=67C3F194",
    role: "Data Science Intern",
    company: "MedTourEasy",
    date: "March 2022 - July 2022",
    desc: "Worked on an ML pipeline for fitness data analysis, identifying cardiovascular health patterns from 10,000+ user activity records.",
    skills: [
      "Python",
      "ScikitLearn",
      "Statsmodels",
      "MatPlotLib",
      "ML Features",
      
    ],
    
  },
  {
    id: 1,
    img: "",
    role: "Frontend Developer Intern",
    company: "AriInnovation",
    date: "March 2025 - July 2025",
    desc: "Collaborated in developing React.js prototype components for cryptocurrency wallet interface, implementing Web3.js integration.Built responsive mockup dashboard using Tailwind CSS and React hooks, showcasing how wellness metrics could connect with reward systems for potential investor demonstrations.",
    skills: [
      "React",
      "TailwindCSS",
      "Web.js",
      "UI/UX",
      "Agile",
      
    ],
    
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://i.pinimg.com/736x/67/fe/fc/67fefce70748390f1652c051c93d2c4d.jpg",
    school: "University Of Massacusetts Amherst",
    date: "Sept 2023 - May 2025",
    grade: "3.7 CGPA",
    desc: "I am currently pursuing Master's degree in Computer Science  at University Of Massacusetts Amherst. I have completed 3 semesters and have a CGPA of 3.7. ",
    degree: "Master Of Science - M.S, Computer Science ",
  },
  {
    id: 1,
    img: "https://d23qowwaqkh3fj.cloudfront.net/wp-content/uploads/2022/01/srm-logo.svg.gzip",
    school: "SRM Institute of Science And Technology",
    date: "July 2019 - July 2023",
    grade: "9.8 CGPA",
    desc: "I completed B.Tech in Computer Science Engineering from SRM Institute of Science and Technology with a CGPA of 9.8",
    degree: "B.TECH, Computer Science With a Specialization in AI and ML",
  },
];

export const projects = [
  
  {
    id: 1,
    title: "CodeCardS",
    date: "Feb 2025 - Mar2025",
    description:
      "Developed a comprehensive educational web application using React, Spring Boot, and MongoDB, featuring interactive courses,flashcards, and note-taking capabilities. Implemented a microservices architecture to enhance scalability and maintainability",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: [
      "React Js",
      "MongoDb",
      "Spring Boot",
      "PostMan",
      "Redux",
      "Microservices",
    ],
    category: "web app",
    github: "https://github.com/sriya632/CodecardS",
    
  },
  {
    id: 10,
    title: "Moon Drop Dale ",
    date: "Oct 2024 - Dec 2024",
    description:
      "Moondrop Dale is a game in which the player is responsible for growing crops, cooking nutritional meals, and completing quests for their fellow villagers—through this process, they learn how to take care of plants and sustain a healthy diet.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["Unit 3D", "C#", "AI","Game Programming"],
    github: "https://github.com/anishard/GameProgramming",
    
  },
  {
    id: 0,
    title: "MediVault",
    date: "Feb 2024 - May 2024",
    description:
      "Designed a blockchain-based health record system using Solidity smart contracts, ensuring 100% tamper-proof storage.Integrated a secure frontend-backend architecture with React and Web3.js, automating deployment via npm scripts and Cypress testing. Configured backend services in Node.js, linking with Polygon Amoy Testnet via Web3.js, supporting 1000+ transactions/month.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["React Js", "Java Script", "Web3 Js", "Solidity", "Node Js", "Smart Contracts", "Blockchain"],
    category: "web app",
    github: "https://github.com/sriya632/Medi_vault",
    
    
  },
  {
    id: 6,
    title: "Unsupervised Segmentation of Abdominal Organs in 4D-MRI Sequences",
    date: "Oct 2023 - Dec 2023",
    description:
      "Developed an unsupervised segmentation model to delineate abdominal organs in 4D-MRI sequences, reducing reliance on manual annotations. Integrated K-Means clustering and 3D CNNs to enhance segmentation precision, addressing noise and motion artifacts. Compared and Evaluated unsupervised models (K-Means, 3D CNNs) against supervised models (U-Net, Mask R-CNN) to determine the most effective approach based on accuracy and feasibility.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["Python", "Machine Learning ", "k-means", "CNN", "3D CNN", "Unsupervised Learning"],
    category: "machine learning",
    
    
  },
  {
    id: 9,
    title: "Counterfeit Product Detection",
    date: "Jan 2023 - Apr 2023",
    description:
      "The Counterfeit Product Detection Using Blockchain project is a system designed to authenticate products and eliminate counterfeit goods by using blockchain technology.The application was developed using Python and Tkinter for the graphical user interface (GUI). The blockchain implementation is managed via the Blockchain.py and Block.py files, which handle the creation, validation, and storage of blocks containing product details.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: [
      "Python",
      "Tkinter",
      "Pickle",
      "Blockchain",
      "Html",
      "Rest Api",
      "Cryptographic Hashing",
      
    ],
    category: "web app", 
    github: "https://github.com/sriya632/counterfeit-product-detection",
    
  },
  
  {
    id: 2,
    title: "FriendsUp",
    date: "Mar 2025 - Apr 2025",
    description:
      "Developed a full-stack web application using Flask for the backend and React with Chakra UI for the frontend, enabling users to create, edit, and delete friend profiles.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["Python", "Flask", "SQLLite", "SQLAlchemy", "Postman", "React"],
    category: "web app",
    github: "https://github.com/sriya632/FriendsUp",

  },
  {
    id: 3,
    title: "Heart Disease Prediction",
    date: "Dec 2022 - Jan 2022",
    description:
      "The project involved analysis of the heart disease patient dataset with proper data processing. Then, different models were trained and and predictions are made with different algorithms KNN, Decision Tree, Random Forest,SVM,Logistic Regression etc.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["python", "scikit-learn", "keras", "numpy"],
    category: "machine learning",
    github: "https://github.com/sriya632/Heart-Disease-Prediction-using-Machine-Learning",
    
  },
  
  {
    id: 4,
    title: "Tweet Emotion Recognition",
    date: "Jul 2022",
    description:
      "Created a recurrent neural network and trained it on a tweet emotion dataset to learn to recognize emotions in tweets. This dataset has thousands of tweets each classified in one of 6 emotions. This project is a multi class classification problem in the natural language processing domain. TensorFlow is used as machine learning framework.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["Python", "Tensoflow", "NLP", "Neural Networks"],
    category: "machine learning",
    github: "https://github.com/sriya632/Tweet-Emotion-Recognition-Using-TensorFlow",
   
  },
  {
    id: 5,
    title: "Disney+ Hotstar Clone",
    date: "Jun 2021",
    description:
      " The Disney+ Hotstar Clone is a static web application that replicates the user interface and experience of the Disney+ Hotstar streaming platform. It allows users to browse TV shows, movies, and sports categories with an interactive and visually appealing UI.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["HTML", "Javascript", "CSS", "jQuery"],
    category: "web app",
    github: "https://github.com/sriya632/Disney-Hotstar-clone",
    
  },
  
  {
    id: 7,
    title: "Rock Paper Scissors",
    date: "Dec 2020 - Jan 2021",
    description:
      "A simple Rock Paper Scissors game made with HTML, CSS, and Javascript. It has a simple UI and is easy to play. It also has a score counter to keep track of the score.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["HTML", "CSS", "Javascript"],
    category: "web app",
    github: "https://github.com/sriya632/Rock_Paper_Scissors",
    
  },
  {
    id: 8,
    title: "Face Mask Recognition",
    date: "Jan 2021",
    description:
      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    
  },
  {
    id: 11,
    title: "MysterAI",
    date: "Apr 2025",
    description:
      "MysteryAI is an interactive AI-driven murder mystery game. It generates dynamic cases using GenAI. Players can interrogate suspects and witnesses. Each case is unique and engaging.",
    image:
      "${process.env.PUBLIC_URL}/PathForward-scaled.jpg",
    tags: ["React", "TailwindCSS", "Firebase", "Google Gemini flash api", "Hugging face transformers", "RAG"],
    category: "web app",
    
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];